module.exports = __webpack_public_path__ + "media/images/emblems/Bettwiesen-Blazono-01304511376ea6b45e0e7d3d5df35530.png";